import axios, { AxiosInstance } from 'axios';
import store from './../store';
import router from './../router';
import ApiError from '@/api/ApiError';

export default class BaseRepository {

    protected axiosClient!: AxiosInstance;
    private baseURL = process.env.VUE_APP_BASE_URL;

    constructor() {
        this.createHttpClient();
        this.setInterceptors();
    }

    private createHttpClient() {
        this.axiosClient = axios.create({
            baseURL: this.baseURL
        });
    }

    private setInterceptors() {
        // -- set token for each request
        this.axiosClient.interceptors.request.use((config: any) => {
            if (store.getters['auth/token']) {
                config.headers.Authorization = `Bearer ${store.getters['auth/token']}`;
            }
            return config;
        }, (error: any) => {
            throw Promise.reject(error);
        });

        // -- normalize response
        this.axiosClient.interceptors.response.use(
            (response: any) => response.data,
            (error: any) => {
                if (error.response) {
                    const status = error.response.status;
                    const message = error.response.data?.message || error.message; // ✅ Extract correct error message

                    if (status === 401 || status === 403 || status >= 500) {
                        switch (status) {
                            case 401:
                                store.commit('auth/clearLogin');
                                router.push({ name: 'login_view' });
                                break;
                            default: // Server errors (500+)
                                throw new ApiError(status, message, error.response.data);
                        }
                    } else {
                        throw new ApiError(status, message, error.response.data);
                    }
                } else {
                    return new Promise(() => {
                        throw Promise.reject(error);
                        // cancels processing of the interceptor chain
                    });
                }

            });
    }
}
